import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addPaymentMethod, getCustomerPaymentMethods } from '../modules/payment_methods';
import { fireEnrollPaymentSuccess, clearEnrollPaymentSuccess } from '../modules/enroll_payment_success';
import { clearEnrollShippingSuccess } from '../modules/enroll_shipping_success';
import { enrollCreateShipping, upgradeCreateAccount } from '../modules/enroll_actions';
import { placeEnrollOrder } from '../modules/order_actions';
import { updateCustomerCore } from '../modules/update_customer_actions';
import PayPalButton from './PayPalButton.jsx';
import { setupHostedFields, setupPaypal, resetPaypalListener, braintreeObjCreate, braintreeObjDestroy } from '../shared/braintreeClientHelper';
import TermsOfMembership from './CmsTermsOfMembership.jsx';
import TermsOfUse from './CmsTermsOfUse.jsx';
import PrivacyPolicy from './CmsPrivacyPolicy.jsx';

class EnrollmentBraintreeDropin extends Component {

  constructor(props) {
    super(props);
    this.oSelected = null;
    this.newPayPalObj = null;
    this.paymentToken = null;
    this.state = {
      viewState: (props.paymentMethods && props.paymentMethods.length > 0) && props.customer.status !== "Cancelled" ? 'selected' : 'add',
      didBrainTreeSubmit:       false,
      terms_error_msg:          null,
      braintreeErrorObj:        null,
      isShowingTermsofUse:      false,
      isShowingMembershipTerms: false,
      isShowingPrivacyPolicy:   false,
      termsChecked:             false
    };

    this.viewNone             = this.viewNone.bind(this);
    this.viewSelected         = this.viewSelected.bind(this);
    this.viewSelectedHard     = this.viewSelectedHard.bind(this);
    this.viewAll              = this.viewAll.bind(this);
    this.viewAdd              = this.viewAdd.bind(this);
    this.closePopup           = this.closePopup.bind(this);
    this.braintreeRefresh     = this.braintreeRefresh.bind(this);
    this.submitSelected       = this.submitSelected.bind(this);
    this.toggleShowingTermsofUse   = this.toggleShowingTermsofUse.bind(this);
    this.toggleShowingMembershipTerms   = this.toggleShowingMembershipTerms.bind(this);
    this.toggleShowingPrivacyPolicy   = this.toggleShowingPrivacyPolicy.bind(this);
    this.setPaymentToken      = this.setPaymentToken.bind(this);
    this.submitEnrollOrder    = this.submitEnrollOrder.bind(this);
    this.braintreeSoftRefresh = this.braintreeSoftRefresh.bind(this);
    this.updateCheckbox       = this.updateCheckbox.bind(this);

    this.braintreeInstantiate = this.braintreeInstantiate.bind(this);
    this.addNewPaypalSubmit   = this.addNewPaypalSubmit.bind(this);
    this.addNewSubmit         = this.addNewSubmit.bind(this);
    this.braintreeFailure     = this.braintreeFailure.bind(this);
  }

  componentDidMount(){
    this.braintreeInstantiate();
  }

  braintreeInstantiate(){
    let { uniqueContainer, font_css, customer, tla } = this.props;
    setupHostedFields( uniqueContainer, font_css, uniqueContainer + "-submit", this.addNewSubmit, this.braintreeFailure )
    setupPaypal( uniqueContainer + "-paypal-container", this.addNewPaypalSubmit, this.braintreeFailure)
    braintreeObjCreate(customer.braintree_token, tla);
  }

  componentWillReceiveProps(nextProps){
    if( this.props.paymentMethods !== nextProps.paymentMethods ){
      if( nextProps.paymentMethods && nextProps.paymentMethods[0] ){
        if(this.state.viewState === 'add') braintreeObjDestroy();
        this.viewSelectedHard();
      }
      this.newPayPalObj = null;
      this.oSelected = null;
    }
  }

  componentWillUnmount(){
    this.notMounted = true;
  }

  addNewPaypalSubmit(obj){
    this.newPayPalObj = obj;
    this.viewSelectedHard();
  }

  addNewSubmit(obj){
    let {clearShippingErrorMsg, validateCheckout, dispatch, customer, storeType, shipping_address, customer_obj, additionalParams } = this.props;
    clearShippingErrorMsg();
    this.setState({
      braintreeErrorObj : {},
      terms_error_msg: null
    });
    if( this.state.didBrainTreeSubmit === false && validateCheckout() && this.checkAcceptTerms() ){
      this.newPayPalObj = null;
      this.setState({
        braintreeErrorObj : null,
        didBrainTreeSubmit: true
      });

      dispatch([
        clearEnrollShippingSuccess(),
        clearEnrollPaymentSuccess()
      ]);

      this.oSelected = {};

      if (obj.type === "PayPalAccount") this.oSelected.email = obj.details.email;
      else {
        this.oSelected.cardType = obj.details.cardType;
        this.oSelected.maskedNumber = "**" + obj.details.lastTwo;
      }
      this.viewSelectedHard();

      if( customer.fulfillment_type && customer.fulfillment_type === "Positive" && storeType === "Neglite" && customer.status !== "Cancelled"){
        let { customer_obj } = this.props,
            oPaymentObj = { nonce: obj.nonce };
        dispatch( upgradeCreateAccount( customer_obj, shipping_address, oPaymentObj, this.setPaymentToken, this.braintreeRefresh) );
      } else {
        if(this.props.customer_obj) dispatch( updateCustomerCore(customer_obj) );
        dispatch( enrollCreateShipping(shipping_address, this.braintreeSoftRefresh, this.submitEnrollOrder) ) ;

        dispatch( addPaymentMethod(obj.nonce, this.setPaymentToken, additionalParams, this.braintreeRefresh ));
      }
    }
  }

  braintreeFailure(err){
    console.log(err);
    this.props.clearShippingErrorMsg();
    this.props.validateCheckout();
    this.setState({ braintreeErrorObj : { message : 'Please fill in all the fields.' } });
  }

  setPaymentToken( token=null,  second_token ){
    this.paymentToken = token || second_token;
    this.props.dispatch( fireEnrollPaymentSuccess() );
    this.submitEnrollOrder();
  }

  submitEnrollOrder(token=null){
    let {dispatch, enrollPaymentSuccess, enrollShippingSuccess } = this.props;
    if( enrollPaymentSuccess && enrollShippingSuccess && ( token || this.paymentToken ) ){
      dispatch([
        clearEnrollPaymentSuccess(),
        clearEnrollShippingSuccess()
      ]);
      dispatch( placeEnrollOrder( null, token || this.paymentToken, this.braintreeRefresh, this.braintreeSoftRefresh));
    }
  }

  braintreeRefresh(){
    let self = this;
    self.viewAdd();
    setTimeout( function(){
      if(!self.notMounted) self.setState({ didBrainTreeSubmit : false})
    }, 1000);
  }

  braintreeSoftRefresh(){
    this.setState({ didBrainTreeSubmit : false });
  }

  viewNone(){
    this.setState({ viewState: 'none'});
  }

  viewSelected(){
    if( !this.props.paymentMethods || !this.props.paymentMethods[0]) this.viewNone();
    else this.setState({ viewState: 'selected'});
  }

  viewSelectedHard(){
    this.setState({ viewState: 'selected'});
  }

  viewAll(){
    braintreeObjDestroy();
    this.setState({ viewState: 'listAll'});
  }

  viewAdd(){
    if (this.state.viewState !== 'add'){
      let self = this;
      this.setState({ viewState: 'add'});
      setTimeout( () => self.braintreeInstantiate(), 250);
    }
  }

  closePopup(){
    if(this.state.viewState === 'add') braintreeObjDestroy();
    if(this.oSelected) this.viewSelectedHard();
    else this.viewNone();
  }

  selectPaymentMethod(paymentMethodObj){
    this.setState({ viewState: 'selected'});
    this.oSelected = paymentMethodObj;
    this.newPayPalObj = null;
  }

  submitSelected(evt){
    evt.preventDefault();
    let { clearShippingErrorMsg, validateCheckout, dispatch, customer, storeType, customer_obj, shipping_address} = this.props;
    clearShippingErrorMsg();
    this.setState({ terms_error_msg: null });
    if ( this.state.didBrainTreeSubmit === false  && validateCheckout() && this.checkAcceptTerms() ){
      this.setState({ didBrainTreeSubmit: true });

      dispatch([
        clearEnrollShippingSuccess(),
        clearEnrollPaymentSuccess()
      ]);

      this.setPaymentToken(this.oSelected.token);

      if(customer.fulfillment_type && customer.fulfillment_type === "Positive" && storeType === "Neglite"){
        dispatch( upgradeCreateAccount( this.props.customer_obj, shipping_address, null, this.submitEnrollOrder, this.braintreeRefresh, true) );
      } else {
        dispatch( enrollCreateShipping( shipping_address, this.braintreeSoftRefresh, this.submitEnrollOrder) );
      }
    }
  }

  toggleShowingTermsofUse() { this.setState({isShowingTermsofUse: !this.state.isShowingTermsofUse, isShowingMembershipTerms: false, isShowingPrivacyPolicy: false }) }

  toggleShowingMembershipTerms() { this.setState({isShowingMembershipTerms: !this.state.isShowingMembershipTerms, isShowingTermsofUse: false, isShowingPrivacyPolicy: false }) }

  toggleShowingPrivacyPolicy() { this.setState({isShowingPrivacyPolicy: !this.state.isShowingPrivacyPolicy, isShowingTermsofUse: false, isShowingMembershipTerms: false }) }

  updateCheckbox(){ this.setState({ termsChecked: !this.state.termsChecked }); }

  checkAcceptTerms(){
    if( this.state.termsChecked ) return true;
    this.setState({ terms_error_msg : 'Please read and agree to the Terms of Use, Membership Terms, and Privacy Policy before completing your order.'});
    return false;
  }

  render() {
    let oPaymentMethodList           = '',
      elem                           = '',
      oSelectedObj                   = '',
      oPaypalObj                     = '',
      oShowChangePaymentMethodButton = '',
      popupContents                  = '',
      braintreeEmbedElem             = '',
      braintreePopupElem             = '',
      paymentMethods                 = this.props.paymentMethods,
      braintreeErrors                = this.state.braintreeErrorObj,
      currentView                    = this.state.viewState,
      extraSpaceClass                = this.props.customer.status === "Upgrading" ? " extra-big-spacing" : (this.props.upgradeStatus ? " extra-spacing" : "");

    if( paymentMethods && currentView !== 'none' ){
      oPaymentMethodList = paymentMethods.map((method, i) => {
        if (method && typeof method === 'object') {
          let oSetDefault = method.default === false ? '': (<span className="text-small">Default</span>);
          let sCardType = method.cardType;
          if (method.cardType === 'American Express' ) sCardType = 'AmEx';
          if( this.oSelected === null && method.default === true ) this.oSelected = method;

          return (
            <li className={ method.default === true ? "default" : ""} onClick={this.selectPaymentMethod.bind(this, method)}  key={'PaymentMethod' + i}>
              <span className="radio-icon"></span>
              { method.cardType ? sCardType + " ending in " + method.maskedNumber.substr(-4,4) : "PayPal " + method.email }
               {oSetDefault}
            </li>
          );
        } else {
          return '';
        }
      });
    }

    if(this.oSelected ){
      oSelectedObj = (
        <li className={ this.oSelected.default === true ? "default" : ""}>
          <div className="payment-info"> { this.oSelected.cardType ? this.oSelected.cardType + " ending in " + this.oSelected.maskedNumber.substr(-4,4) : "PayPal " + this.oSelected.email } </div>
        </li>
      );
    }

    if(this.newPayPalObj ){
      oPaypalObj = (
        <li>
          <div className="payment-info"> { "PayPal " + this.newPayPalObj.details.email } </div>
        </li>
      );
    }

    oShowChangePaymentMethodButton = this.state.didBrainTreeSubmit === true ? '' : ( <div className="edit-link" onClick={this.viewAll}>Change Payment Method</div>);

    if( currentView === 'selected'){
      braintreeEmbedElem = (
      <div className="selectedPayment showing">
        <div className="selectedObj">
          { this.newPayPalObj ? oPaypalObj : oSelectedObj }
          {oShowChangePaymentMethodButton}
        </div>

        <div className={"terms-of-membership-box hidden unselectable" + (this.state.isShowingMembershipTerms ? " showing" + extraSpaceClass : "")}>
          <TermsOfMembership />
        </div>

        <div className={"terms-of-membership-box hidden unselectable" + (this.state.isShowingTermsofUse ? " showing" + extraSpaceClass : "")}>
          <TermsOfUse />
        </div>

        <div className={"terms-of-membership-box hidden unselectable" + (this.state.isShowingPrivacyPolicy ? " showing" + extraSpaceClass : "")}>
          <PrivacyPolicy />
        </div>

        <div className={"full-width bordered-box center terms-box hidden showing" + ( ( !this.state.isShowingMembershipTerms && !this.state.isShowingTermsofUse && !this.state.isShowingPrivacyPolicy )  ? extraSpaceClass : "")}>
          <label>
            { this.state.terms_error_msg ? (<p className="errorMessage"> {this.state.terms_error_msg} </p>) : '' }
            <input type="checkbox" name="acceptTerms" required onChange={this.updateCheckbox} checked={this.state.termsChecked} />
              <span>By clicking the checkbox above, you agree to {this.props.store.name}’s </span><a onClick={this.toggleShowingTermsofUse}>Terms of Use</a>, <a onClick={this.toggleShowingMembershipTerms}>Membership Terms</a>, and <a onClick={this.toggleShowingPrivacyPolicy}>Privacy Policy</a>. 
              {this.props.store.type == 'Neglite' ? `You also acknowledge that you are signing up for a recurring monthly subscription. Unless you skip the month, or cancel your subscription on this site prior to the 10th day of each month, you will be renewed for ${this.props.store.two_credits} plus tax and two credits will be added to your account redeemable for your next book.` : `You also acknowledge that your are signing up for a negative option subscription. Every few weeks you will be notified via email of our new featured selections. Unless you skip, or cancel your subscription on this site prior to the date indicated in the email, you will be shipped the featured selections and the payment method on file will be charged at the appropriate price for the books plus tax.` }
          </label>
          <button
            className="btn-primary fat full-width" 
            type="submit"
            id={ currentView !== 'add' ? this.props.uniqueContainer + "-submit" : ""}
            onClick={ this.newPayPalObj ? this.addNewSubmit.bind(this, this.newPayPalObj) : this.submitSelected } >
              { this.state.didBrainTreeSubmit === false ? "Place Order" : "Pending..." }
          </button>
        </div>
      </div>
      );
    } else if( currentView === 'none'){
      braintreeEmbedElem = (
        <div className="noPaymentMethod showing">
          <p>You do not have a payment method on file. Please add a payment method to make a purchase.</p>
          <button className="btn-primary fat full-width" onClick={this.viewAdd}>Add Payment Method</button>
        </div>
      );
    }

    switch( currentView ) {
      case 'listAll':
        popupContents = (
          <ul className="paymentMethodList showing">
            {oPaymentMethodList}
            <li onClick={this.viewAdd} className="button"><div className="btn-icon">+</div>Add Another Payment Method</li>
            <div className="help-link center" onClick={this.closePopup}> cancel </div>
          </ul>
        );
        break;
      case 'add':
        popupContents = (
          <div className="hostedFieldForm showing" id={this.props.uniqueContainer}>
            {(braintreeErrors && braintreeErrors.message) || (this.props.braintreeFailure && !this.state.didBrainTreeSubmit) ?
              (<p className="errorMessage">{ braintreeErrors && braintreeErrors.message ? braintreeErrors.message : this.props.braintreeFailure }</p>) : ''}

              <label>Credit Card Number</label>
              <div id="card-number" className="hostedFieldInput"></div>

              <label>CVV</label>
              <div id="cvv" className="hostedFieldInput"></div>

              <label>Expiration Date (MM/YYYY)</label>
              <div id="expiration-date" className="hostedFieldInput"></div>

              <label>Zipcode</label>
              <div id="postalCode" className="hostedFieldInput"></div>

              { this.props.tla === "DVD" ? (<div />) : (<div className="center ">- or use PayPal -</div>)}
              { this.props.tla === "DVD" ? (<div />) : (
                <div id={this.props.uniqueContainer + "-paypal-container"} className="bt-paypal-button">
                  <PayPalButton />
                </div>
              )}

              <div className={"terms-of-membership-box hidden unselectable" + (this.state.isShowingMembershipTerms ? " showing" + extraSpaceClass : "")}>
                <TermsOfMembership />
              </div>

              <div className={"terms-of-membership-box hidden unselectable" + (this.state.isShowingTermsofUse ? " showing" + extraSpaceClass : "")}>
                <TermsOfUse />
              </div>

              <div className={"terms-of-membership-box hidden unselectable" + (this.state.isShowingPrivacyPolicy ? " showing" + extraSpaceClass : "")}>
                <PrivacyPolicy />
              </div>

              <div className={"full-width bordered-box center terms-box hidden showing" + ( (!this.state.isShowingMembershipTerms && !this.state.isShowingTermsofUse && !this.state.isShowingPrivacyPolicy) ? extraSpaceClass : "")}>
                <label>
                  { this.state.terms_error_msg ? (<p className="errorMessage"> {this.state.terms_error_msg} </p>) : '' }
                  <input type="checkbox" name="acceptTerms" required onChange={this.updateCheckbox} checked={this.state.termsChecked} />
                    <span>By clicking the checkbox above, you agree to {this.props.store.name}’s </span><a onClick={this.toggleShowingTermsofUse}>Terms of Use</a>, <a onClick={this.toggleShowingMembershipTerms}>Membership Terms</a>, and <a onClick={this.toggleShowingPrivacyPolicy}>Privacy Policy</a>. 
                    {this.props.store.type == 'Neglite' ? `You also acknowledge that you are signing up for a recurring monthly subscription. Unless you skip the month, or cancel your subscription on this site prior to the 10th day of each month, you will be renewed for ${this.props.store.two_credits} plus tax and two credits will be added to your account redeemable for your next book.` : `You also acknowledge that your are signing up for a negative option subscription. Every few weeks you will be notified via email of our new featured selections. Unless you skip, or cancel your subscription on this site prior to the date indicated in the email, you will be shipped the featured selections and the payment method on file will be charged at the appropriate price for the books plus tax.` }
                </label>
                <button disabled={true} id={this.props.uniqueContainer + "-submit"} className="btn-primary fat full-width" type="submit">{ this.state.didBrainTreeSubmit === false ? "Place Order" : "Pending..." }</button>
              </div>

            <div className="help-link center" onClick={ !paymentMethods || !paymentMethods[0] ? this.viewNone : this.viewAll}> cancel </div>
          </div>
        );
        break;
    }

    if( popupContents ){
      braintreePopupElem = (
        <div className="showing">
          <div className="modal-close" onClick={this.closePopup}>&times;</div>
          {popupContents}
        </div>
      );
    }

    return (
      <div className="braintreeObj">
          {braintreeEmbedElem}
          {braintreePopupElem}
      </div>
    );
  }
};


function mapStateToProps(state){
    return {
      'customer': state.customer,
      'enrollShippingSuccess': state.enrollShippingSuccess,
      'enrollPaymentSuccess': state.enrollPaymentSuccess,
      'paymentMethods': state.paymentMethods,
      'braintreeFailure': state.braintreeFailure,
      'tla': state.store.tla,
      'font_css': state.store.font_css,
      'storeType': state.store.type,
      'upgradeStatus': state.upgradeStatus,
      'store': state.store,
    };
}

export default connect(mapStateToProps, null, null, {withRef: true})(EnrollmentBraintreeDropin);


// WEBPACK FOOTER //
// ./src/components/EnrollmentBraintreeDropin.jsx